export const INITIALIZE_PRACTICE = 'INITIALIZE_PRACTICE'
export const CHOOSE_ANSWER = 'CHOOSE_ANSWER'
export const VALIDATE_ANSWER_REQUEST = 'VALIDATE_ANSWER_REQUEST'
export const VALIDATE_ANSWER_SUCCESS = 'VALIDATE_ANSWER_SUCCESS'
export const SHOW_NEXT_QUESTION = 'SHOW_NEXT_QUESTION'
